const words = ["Unternehmensnachfolge", "IT-Modernisierung", "Arbeitsplatzarchitektur", "Due-Diligence-bereit", "Wertsteigerung", "Mittelstand"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {words.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`font-serif-d px-8 text-5xl tracking-tight sm:text-7xl lg:text-8xl ${i % 2 ? "italic text-[var(--clay)]" : "text-[var(--ink)]"}`}>{w}</span>
        <span className="h-3 w-3 rotate-45 border border-[var(--ink)]/50" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" aria-label="Themen" className="overflow-hidden border-y border-[var(--line)] bg-[var(--stone-2)] py-8 sm:py-10">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
